var staticDayTime = 86400000

module.exports = staticDayTime



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticDayTime.js
// module id = 140
// module chunks = 75